module.exports = __webpack_public_path__ + "img/4.c4732f7b.jpg";